// src/js/components/show-more-button.js
var ShowMoreButton = class extends HTMLElement {
  /**
   * Construct
   */
  constructor() {
    super();
    this.gallery = document.querySelector(".product__media-list--show-more");
    this.button = this.querySelector("button");
    this.init();
  }
  /**
   * Init
   */
  init() {
    if (this.gallery == void 0) {
      return;
    }
    this.button?.addEventListener("click", () => {
      this.toggleMediaList();
    });
  }
  /**
   * Toggle Media List
   */
  toggleMediaList() {
    this.gallery.classList.toggle("is-collapsed");
    if (this.gallery.classList.contains("is-collapsed")) {
      this.gallery.scrollIntoView({
        behavior: "smooth"
      });
    }
  }
};
customElements.define("show-more-button", ShowMoreButton);
